import { useRouteError } from 'react-router'
import ErrorBoundaryUI from './ErrorBoundaryUI'

const AppRoutesErrorElement: React.FC = () => {
  const error = useRouteError()

  // Render ErrorBoundaryUI instead of the default 'Unexpected Application Error'
  return <ErrorBoundaryUI error={error as Error} resetError={() => window.location.reload()} />
}

export default AppRoutesErrorElement
